import { BehaviorSubject } from 'rxjs';

const disabledBtnTurn$ = new BehaviorSubject(false);
export const getDisabledBtnTurn = () => disabledBtnTurn$.asObservable();
export const setDisabledBtnTurn = (value) => disabledBtnTurn$.next(value);

const idArrDisabled$ = new BehaviorSubject([]);
export const getIdArrDisabled = () => idArrDisabled$.asObservable();

const isFirstItemDone$ = new BehaviorSubject(false);
export const firstItemService = {
  // Observable para suscribirse
  isFirstItemDone$: isFirstItemDone$.asObservable(),
  // método para actualizar el valor
  setIsFirstItemDone: (value) => {
    isFirstItemDone$.next(value);
  }
};

let awbNext = false;
let awbValue = '';
let turn_id = '';

export const setValidateAwb = (value) => {
  awbValue = value;
  if(awbValue === "" || awbValue === "139-") {
    awbNext = false;
  } else {
    awbNext = true;
  }
}

export const validateAwb = async () => {
  if(!awbNext) {
    if(awbValue === "" || awbValue ==="139-") {
      return {status: false, message:'Todos los embarques deben tener un número de guía antes de continuar.'}
    }
  }

  return {status: true, message: "Coninue with the validation"}
}

export const setTunrId = (id) => {
  turn_id = id;
}

export const getTurnId = async () => {
  return turn_id;
}

export const addIdArrDisabled = (id) => {
  const current = idArrDisabled$.value;
  if (!current.includes(id)) {
    idArrDisabled$.next([...current, id]);
  }
};

export const finishTurnAlert = async (data) => {
  const allDisabled = data.every(item => idArrDisabled$.value.includes(item.id));
  return allDisabled;
}

export const resetTurnState = () => {
  disabledBtnTurn$.next(false); // habilitar botón
  idArrDisabled$.next([]);      // limpiar lista de ids
  awbNext = false;
  awbValue = '';
  turn_id = '';
};